import { ModalHandler } from './modalHandler/modalHandler'
import { ModalCloseButtonHandler } from './modalCloseButtonHandler/modalCloseButtonHandler'

export default () => {
	const initAll = (reinit = false) => {
		initTippy(reinit)
	}

	const initTippy = (reinit = false) => {
		ModalCloseButtonHandler.init()

		if (!reinit) {
			ModalHandler.init()
		}
	}

	return {
		initAll,
		initTippy,
	}
}
